import { render, staticRenderFns } from "./BaseChatTypingIndicator.vue?vue&type=template&id=e97b75e4&scoped=true&"
import script from "./BaseChatTypingIndicator.vue?vue&type=script&lang=js&"
export * from "./BaseChatTypingIndicator.vue?vue&type=script&lang=js&"
import style0 from "./BaseChatTypingIndicator.vue?vue&type=style&index=0&id=e97b75e4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e97b75e4",
  null
  
)

export default component.exports